import React, { Component } from 'react';

//componentes
import PagosRecibidos from './pagosRecibidos'

class Index extends Component {

    render(){
        return(
            <div>
                <PagosRecibidos />
            </div>
        );
    }

}
export default Index;